var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('pf-terminal-statistics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }